const url = import.meta.env.VITE_SOCKET_URL
export let ws = {}
export function connect(roomId) {
  ws = new WebSocket(`${url}/${localStorage.getItem('uuid')}/room/${roomId}`)

  ws.onerror = (error) => {
    console.error(`[${new Date().toISOString()}] WebSocket error:`, error)
    console.error('WebSocket readyState:', ws.readyState)
    console.error('WebSocket URL:', ws.url)
  }
}
